import React from 'react';

import { getLocaleFormat } from '@/utils/getLocaleFormat';

export function AvailableForPreOrderBanner({
  approxLaunchDate,
}: {
  approxLaunchDate: string;
}) {
  const date = new Date(approxLaunchDate).toLocaleString(getLocaleFormat(), {
    year: 'numeric',
    month: 'long',
  });

  return (
    <div className="-mt-px border-y border-y-green-matte-100 bg-green-matte-50 px-4 py-2 md:px-8">
      <p className="text-green-gloss text-center text-sm">
        <span className="font-bold">Coming soon</span>
        <svg
          viewBox="0 0 2 2"
          className="mx-2 inline h-0.5 w-0.5 fill-current"
          aria-hidden="true"
        >
          <circle cx="1" cy="1" r="1"></circle>
        </svg>
        <span>Launching {date}</span>
      </p>
    </div>
  );
}
